import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { AppTokenService } from "../app-token.service";
import { HttpHandlerService } from "../http-handler.service";
@Injectable()

export class ManifestService {
    _httpHandler: HttpHandlerService;
    _apiUrl = environment.apiUrl;
    _resourceEndPoint = 'manifest';
    _bagResourceEndPoint = 'bags';
    // _getAWBListEndPoint = 'manifest/availablechildAwbs';
    _ediResourceEndPoint = 'edi';

    constructor(private httpHandler: HttpHandlerService, private appTokenService: AppTokenService) {
        this._httpHandler = httpHandler;
    }

    public GetAll(params?: any): Observable<any> {
        let full_api_url = `${this._apiUrl}${this._resourceEndPoint}/list?sc=${params?.scid}&generatedby=${params?.generatedby}&inboundcheck=${params?.inboundcheck}&outboundcheck=${params?.outboundcheck}`
        if (params?.refresh) {
            full_api_url = full_api_url + `&refresh=${new Date().getTime()}`
        }
        
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            params
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetById(manifestsId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}/${manifestsId}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public Add(params: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            params
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public Update(manifestsData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            manifestsData
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public DeleteById(manifestsId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}/${manifestsId}`;
        const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public GetAwbDetailsById(Id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}/${Id}/awbdetails`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public GetAwbDetailsForExcelById(Id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}/${Id}/excel/awbdetails`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public AddAwb(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}/awb`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public DeleteAwbById(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}/awb`;
        const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, data);
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public updateStatus(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}/status`
        const request_option = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GeneratePDF(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}/print`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    //Bagging
    public GetAllBags(id): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._bagResourceEndPoint}?sc=${id}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public ManageBag(bag: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._bagResourceEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            bag
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public DeleteBag(params?: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._bagResourceEndPoint}/${params?.id}?sc=${params?.scid}`;
        const request_options = this._httpHandler.prepareRequest(
            'DELETE',
            full_api_url
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public FilterManifestCustomerWise(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}/filtermanifest`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public GetEDINo(scid: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}/edi?sc=${scid}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public GenerateZIP(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}/zip`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public UpdateStatus(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}/awb/updatestatus`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public GenerateTiff(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}/zip/tiff`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }
}   